import { useQuery } from "@tanstack/react-query";
import { useAdminSession } from "@/hooks/useAdminSession";
import { getAdminStats, getHealth } from "./stats";

export function useAdminStats() {
  const enabled = useAdminSession();
  return useQuery({
    queryKey: ["admin", "stats"],
    enabled,
    queryFn: () => getAdminStats(),
    staleTime: 30_000,
  });
}

export function useHealth() {
  return useQuery({
    queryKey: ["health"],
    queryFn: () => getHealth(),
    staleTime: 30_000,
    retry: false,
  });
}